/*
  The file types a drop or a picker can be told to take, in the `accept` attribute's own syntax so
  one list serves both. Held apart from `file-intake-util.ts` because they are values rather than
  types, and a caller naming what it takes does not want the util.
*/

/** Matched on the file's name, which is the half that is always there. */
export enum FileExtension {
  CSV = '.csv',
  DOC = '.doc',
  DOCX = '.docx',
  GIF = '.gif',
  HEIC = '.heic',
  HEIF = '.heif',
  JPEG = '.jpeg',
  JPG = '.jpg',
  JSON = '.json',
  MD = '.md',
  PDF = '.pdf',
  PNG = '.png',
  RTF = '.rtf',
  TIF = '.tif',
  TIFF = '.tiff',
  TXT = '.txt',
  WEBP = '.webp',
}

/**
 * Matched on the type the browser reports. Worth stating alongside the extension rather than
 * instead of it: a file dragged from some places arrives with no type at all, and plenty arrive as
 * `application/octet-stream`.
 */
export enum FileMimeType {
  CSV = 'text/csv',
  DOC = 'application/msword',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  IMAGE = 'image/*',
  JSON = 'application/json',
  PDF = 'application/pdf',
  TEXT = 'text/plain',
}

/**
 * What a `FileIntake` takes. A union rather than `string[]`, so `'pdf'` and `'image'` - neither of
 * which the matcher can do anything with - are caught where they are written.
 */
export type FileIntakeAccept = FileExtension | FileMimeType;
